<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table
      ref="table"
      multiple
      v-model="selected"
      pagination
      :max-items="itemsPerPage"
      search
      :data="configs"
      class="card-table"
    >
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <vs-button
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            color="primary"
            type="border"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" /> {{ $t('button.add_new') }}
          </vs-button>

          <!-- Delete -->
          <vs-button
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            color="primary"
            type="border"
            @click="openConfirmMultiple"
          >
            <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" /> {{ $t('button.delete') }}
          </vs-button>
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span class="mr-2"
              >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} -
              {{
                configs.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : configs.length
              }}
              of {{ queriedItems }}</span
            >
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage = 5">
              <span>{{ 5 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 10">
              <span>{{ 10 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 50">
              <span>{{ 50 | persian_digits }}</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage = 100">
              <span>{{ 100 | persian_digits }}</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="key">key</vs-th>
        <vs-th sort-key="value">value</vs-th>
        <vs-th>{{ $t('NavMenuItem.SystemSection.RolesPage.Action') }}</vs-th>
      </template>

      <template slot-scope="{ data }">
        <tbody v-if="data.length">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td>
              <p class="config-name font-medium truncate">{{ tr.key }}</p>
            </vs-td>

            <vs-td>
              <p class="config-category">{{ tr.value.join(', ') }}</p>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="openConfirm(tr)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import DataViewSidebar from './ConfigSidebar.vue'

export default {
  components: {
    DataViewSidebar
  },
  data() {
    return {
      configs: [],

      selected: [],
      itemsPerPage: 4,
      isMounted: false,

      deleteMultipleDataFlag: true,

      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {
        item: {}
      }
    }
  },
  computed: {
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.configs.length
    }
  },
  methods: {
    addNewData() {
      this.sidebarData.item = {}
      this.toggleDataSidebar(true)
    },
    openConfirm(data) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: `Are you sure to delete ${data.key} .`,
        accept: () => this.deleteData(data.id)
      })
    },
    openConfirmMultiple() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm',
        text: 'Are you sure to delete all the selected configs?',
        accept: this.deleteMultipleData
      })
    },
    deleteData(id) {
      this.$store
        .dispatch('config/removeConfig', id)
        .then(response => {
          this.$notifySuccess(
            `With this ${response.data.role}, ${response.data.resource}, ${response.data.action}`,
            'Object Deleted'
          )
          this.configs = this.configs.filter(configs => configs.id !== id)
        })
        .catch(error => this.$notifyError(error, 'An Error Occurred'))
    },
    deleteMultipleData() {
      if (this.selected.length > 0) {
        for (let i = 0; i < this.selected.length; i++) {
          this.$store
            .dispatch('config/removeConfig', this.selected[i].id)
            // eslint-disable-next-line no-unused-vars
            .then(response => {
              this.configs = this.configs.filter(configs => configs.id !== this.selected[i].id)
            })
            .catch(() => {
              this.deleteMultipleDataFlag = false
            })
        }
        if (this.deleteMultipleDataFlag) {
          this.$notifySuccess('All configs removed successfully', 'Deleted all')
        } else {
          this.$notifyError({ message: 'Somethings goes wrong, look at the console.' })
        }
        this.deleteMultipleDataFlag = true
      } else {
        this.$notifyWarning('Nothing to delete', 'Information')
      }
    },
    editData(data) {
      this.sidebarData.item = data
      this.toggleDataSidebar(true)
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    }
  },
  mounted() {
    this.isMounted = true
    this.$store.dispatch('config/fetchConfigs').then(() => {
      this.configs = this.$store.state.config.configs
    })
  }
}
</script>
